<template>
  <div
    v-if="enrollment"
    class="column rounded tournament-white elevate-3d elevate-3"
    style="min-height: 86px; border-left: 10px solid; overflow: hidden"
    :class="border"
  >
    <div class="row align-center flex pl-4 py-2">
      <!-- Event name -->
      <div
        v-if="enrollment.event && enrollment.event.name"
        class="column tournament-white--text mr-2"
        style="width: 200px"
      >
        <span class="caption tournament-grey--text">Nome do evento</span>
        <div
          class="row justify-middle subheading ellipsis-2 tournament-dark-blue--text"
          style="line-height: normal; min-height: 24px"
        >
          {{ enrollment.event.name }}
        </div>
      </div>

      <!-- Enrollment status -->
      <div class="column flex tournament-white--text mx-2" style="width: 152px">
        <span
          v-if="
            enrollment.situation
              && enrollment.situation.status
              && enrollment.situation.status._id
              && enrollment.situation.status._id != 'waiting'
          "
          class="caption tournament-grey--text"
        >Status</span>
        <div
          v-if="
            enrollment.situation
              && enrollment.situation.status
              && enrollment.situation.status._id
              && enrollment.situation.status._id != 'waiting'
          "
          class="row align-center"
          style="line-height: normal; min-height: 24px"
        >
          <EnrollmentChip v-model="enrollment.situation.status" />
        </div>
      </div>
    </div>

    <!-- Enrollment Situation Notes -->
    <div
      v-if="enrollment.situation && enrollment.situation.notes"
      class="column justify-middle pl-4 py-2"
      style="min-height: 36px; background: #feedf0"
    >
      <div class="row tournament-red--text">
        <div class="column mr-2">
          <v-icon color="tournament-red" style="font-size: 18px">
            error_outline
          </v-icon>
        </div>
        <div class="row caption ellipsis-1 mr-2">
          {{ enrollment.situation.notes }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import EnrollmentChip from "@/components/Enrollments/Chip";

export default {
  name: "JudgeCard",

  components: {
    EnrollmentChip,
  },
  props: {
    enrollment: {
      type: Object,
      required: true,
    },
  },

  computed: {
    border() {
      const status = _.get(this.enrollment, "situation.status._id");
      if (!status) {
        return "tournament-grey-outline";
      }

      switch (status) {
        case "waiting":
          return "tournament-red-outline";

        case "reviewing":
          return "tournament-yellow-outline";

        case "finished":
          return "tournament-grey-outline";

        case "confirmed":
          return "tournament-green-outline";

        case "rejected":
          return "tournament-black-outline";

        case "pending_payment":
          return "tournament-yellow-outline";

        default:
          return "tournament-red-outline";
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Judge/Card/index.vue